// extracted by css-extract-rspack-plugin
export default {"banner":"GGABOyLthkEKBAlF"};